import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";
import styles from "./Breadcrumbs.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);
type Props = {
  /**
   * A string representing the breadcrumb path.
   */
  breadcrumbPath: string;
  /**
   * A boolean on whether this is beauty simplification
   */
  beautySimplification: boolean;
  /**
   * A string representing the breadcrumb position.
   */
  breadcrumbsPosition?: string;
};

export const BreadcrumbsUI = ({
  breadcrumbPath,
  beautySimplification,
  breadcrumbsPosition = "one",
}: Props) => {
  return (
    <div
      data-testid="breadcrumbs"
      className={cx("esi-wrapper", {
        beautySimplification,
        breadcrumbsPositionTwo: breadcrumbsPosition === "two",
      })}
      data-component="Breadcrumbs"
    >
      <ESIInclude src={breadcrumbPath} id={"breadcrumbs"} />
    </div>
  );
};
